import { c as _c } from "react/compiler-runtime";
import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import Grid from '@mui/material/Grid';
import { forwardRef } from 'react';
import { ApprovalLikelihoodProvider } from 'src/features/approval-odds/context';
import { useReviewContext } from '../../Context';
import BottomLine from './BottomLine';
import ReviewDetailAccordions from './DetailAccordions';
import ReviewProductCard from './ProductCard';
import ReviewVideo from './Video';
const MainProductCard = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BottomLine />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== ref) {
    t1 = <ReviewProductCard ref={ref} />;
    $[1] = ref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ReviewDetailAccordions />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <>{t0}{t1}{t2}</>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
});
export function ReviewSummary() {
  const $ = _c(13);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    id,
    analytics: t1,
    displayName,
    name,
    institution: t2,
    product: t3
  } = t0;
  const {
    monetizable
  } = t1;
  const {
    id: institutionId,
    name: institutionName
  } = t2;
  const {
    id: productId,
    name: productName
  } = t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MainProductCard />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== displayName || $[2] !== id || $[3] !== institutionId || $[4] !== institutionName || $[5] !== monetizable || $[6] !== name || $[7] !== productId || $[8] !== productName) {
    t5 = <AnalyticsSkuViewed id={id} name={name} monetizable={monetizable} impressionSection="review_product_card" impressionPosition={0} institutionId={institutionId} institutionName={institutionName} offerId={id} offerName={displayName} productId={productId} productName={productName}>{t4}</AnalyticsSkuViewed>;
    $[1] = displayName;
    $[2] = id;
    $[3] = institutionId;
    $[4] = institutionName;
    $[5] = monetizable;
    $[6] = name;
    $[7] = productId;
    $[8] = productName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ReviewVideo />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <ApprovalLikelihoodProvider><Grid container={true}>{t5}{t6}</Grid></ApprovalLikelihoodProvider>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
export default ReviewSummary;